<template>
  <div
    v-if="localValue.type === 'radio'"
    :id="'localValue' + index"
    :style="
      'margin: ' + styles.margin.join('px ') + 'px;' +
      'text-align: ' + styles.text.textAlign + ';' +
      'color:' + styles.text.color + ';' +
      styles.customStyles ?? ''
    "
  >
    <p
      class="text-sm font-semibold"
      :style="
        'color:' + styles.labelColor + ';'
      "
    >
      {{ localValue.label }}
      <span
        v-if="
          localValue.mandatory === true ||
          localValue.mandatory === 1 ||
          localValue.mandatory === 'true'
        "
        style="color: red; font-weight: bold"
        >*</span
      >
    </p>
    <div
      :style="
        'padding: ' + styles.padding.join('px ') + 'px;' +
        'font-family:' + (styles.text.fontFamily || '') + ';' +
        'text-shadow:' + (styles.text.textShadow || '') + ';' +
        'font-size:' + styles.text.fontSize + 'px;' +
        'text-align:' + styles.text.textAlign + ';' +
        'font-style:' + (styles.text.fontStyle || '') + ';' +
        'font-weight:' + (styles.text.fontWeight || '') + ';' +
        'letter-spacing:' + (styles.text.letterSpacing || '') + ';' +
        'line-height:' + (styles.text.lineHeight || '') + ';' +
        '-webkit-text-stroke-width:' + (styles.text.textStrokeWidth || '') + ';' +
        '-webkit-text-stroke-color:' + (styles.text.textStrokeColor || '') + ';' +
        'text-decoration-line:' + (styles.text.textDecorationLine || '') + ';' +
        'color:' + styles.text.color + ';' +
        styles.customStyles ?? ''
      "
    >
      <div
        v-for="(value, index) in localValue.options"
        :key="index"
        class="mt-2 flex"
        :style="
          'justify-content: ' + styles.text.textAlign + ';' +
          'color:' + styles.text.color + ';'
        "
      >
        <label class="radio-container text-sm" style="display: inline-block; width: auto;">
          {{ value }}
          <input id type="radio" :name="localValue.label" />
          <span
            class="radio-checkmark"
            :style="
            '--form-style-color:' + styles.iconColor + ';' +
            '--form-style-background:' + styles.backgroundColor"
          ></span>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'FormRadio',
  props: {
    value: {
      required: true,
    },
    index: {
      required: true,
    },
    styles: {
      required: true,
    },
  },
  computed: {
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    hide() {
      this.localValue = '';
      this.localShown = false;
    },
    onTextChange(e) {
      console.log(e.target.innerText);
      this.localValue = e.target.innerText;
    },
  }
}
</script>
